import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  adminId: [],
};
const adminIdSlice = createSlice({
  name: 'adminId',

  initialState,
  reducers: {
    setAdminId: (state: any, action: PayloadAction<any>) => {
      state.adminId = action.payload;
    },
    removeAdminId: (state: any) => {
      state.adminId = [];
    },
  },
});

export const { setAdminId, removeAdminId } = adminIdSlice.actions;

export default adminIdSlice.reducer;
